import {DriftskontraktAction, DriftskontraktModel} from "../Driftskontrakt/update";
import {GeneriskAction, GeneriskModel} from "../GeneriskeRapporter/update";
import React from "react";
import {UIAction} from "../../update/ui";
import tw from "twin.macro";
import SingleObjectSelection from "./SingleObjectSelection";

interface MultipleObjectSelectionProps {
  state: DriftskontraktModel | GeneriskModel;
  dispatch: React.Dispatch<DriftskontraktAction> | React.Dispatch<GeneriskAction>;
  uiDispatch: React.Dispatch<UIAction>;
  title?: string;
}

export default function MultipleObjectSelection({
  state,
  dispatch,
  uiDispatch,
  title = 'Velg objekttyper',
}: MultipleObjectSelectionProps){
  return (
    <>
      <h3 style={tw`text-xl font-bold text-left m-0 w-full`}>{title}</h3>
      <SingleObjectSelection
        state={state}
        dispatch={dispatch}
        uiDispatch={uiDispatch}
        vegobjekt={state.selectedVegobjekt}
        onSelect={(type) =>
          dispatch({
            type: "SelectOneVegobjekt",
            payload: type,
          })
        }
        title="Vegobjekttype"
        filter={state.selectedSecondaryVegobjekt.extractNullable()?.navn ?? ''}
      />
      <SingleObjectSelection
        state={state}
        dispatch={dispatch}
        uiDispatch={uiDispatch}
        vegobjekt={state.selectedSecondaryVegobjekt}
        onSelect={(type) =>
          dispatch({
            type: "SelectSecondaryVegobjekt",
            payload: type,
          })
        }
        title="Vegobjekttype som overlapper"
        filter={state.selectedVegobjekt.extractNullable()?.navn ?? ''}
      />
    </>
  );
}